const certificates = {
    firestorePath: '/certificates',
    firestoreRefType: 'collection',
    moduleName: 'certificates',
    statePropName: 'certificates',
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
            updated_at: '%convertTimestamp%', // default
        },
    },
    state: {
        certificates: [],
    },
    getters: {
        getAllCertificates: (state) => {
            return _.toArray(state.certificates);
        },
        getCertificates: (state) => {
            let certificates = _.toArray(state.certificates);
            return certificates.filter(certificates => certificates.standard === true)
        },
    },
    mutations: {

    },
    actions: {

    },
}

export default certificates